<mat-tab-group animationDuration="0ms" [preserveContent]="true" [selectedIndex]="selectedTabIndex()" (selectedIndexChange)="onTabIndexChange($event)">
  @if (visibleTabs()['details']) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-full">Details</span>
        <span class="tab-short">Details</span>
      </ng-template>
      <app-details-tab />
    </mat-tab>
  }
  @if (isEditMode && visibleTabs()['process'] && visibleTabs()['details']) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-full">Status</span>
        <span class="tab-short">Status</span>
      </ng-template>
      <ng-template matTabContent>
        <app-process-tab (saved)="onProcessSaved()" />
      </ng-template>
    </mat-tab>
  }
  @if (isEditMode && visibleTabs()['collection']) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-full">Collection</span>
        <span class="tab-short">Collect.</span>
      </ng-template>
      <ng-template matTabContent>
        <app-collection-tab />
      </ng-template>
    </mat-tab>
  }
  @if (isEditMode && visibleTabs()['process'] && !visibleTabs()['details']) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-full">Status</span>
        <span class="tab-short">Status</span>
      </ng-template>
      <ng-template matTabContent>
        <app-process-tab (saved)="onProcessSaved()" />
      </ng-template>
    </mat-tab>
  }
  @if (isEditMode && visibleTabs()['audit1']) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-full">Audit 1</span>
        <span class="tab-short">Aud. 1</span>
      </ng-template>
      <ng-template matTabContent>
        <app-audit1-tab [keywords]="companyKeywords()" (keywordsUpdated)="onKeywordsUpdated($event)" />
      </ng-template>
    </mat-tab>
  }
  @if (isEditMode && visibleTabs()['audit2']) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-full">Audit 2</span>
        <span class="tab-short">Aud. 2</span>
      </ng-template>
      <ng-template matTabContent>
        <app-audit2-tab [keywords]="companyKeywords()" (keywordsUpdated)="onKeywordsUpdated($event)" />
      </ng-template>
    </mat-tab>
  }
  @if (isEditMode && visibleTabs()['board']) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-full">Board</span>
        <span class="tab-short">Board</span>
      </ng-template>
      <ng-template matTabContent>
        <app-board-tab [keywords]="companyKeywords()" (keywordsUpdated)="onKeywordsUpdated($event)" />
      </ng-template>
    </mat-tab>
  }
  @if (isEditMode && visibleTabs()['committees']) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-full">Committees</span>
        <span class="tab-short">Comm.</span>
      </ng-template>
      <ng-template matTabContent>
        <app-committees-tab [keywords]="companyKeywords()" (keywordsUpdated)="onKeywordsUpdated($event)" />
      </ng-template>
    </mat-tab>
  }
  @if (isEditMode && visibleTabs()['ownership']) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-full">Ownership</span>
        <span class="tab-short">Owner.</span>
      </ng-template>
      <ng-template matTabContent>
        <app-ownership-tab [keywords]="companyKeywords()" (keywordsUpdated)="onKeywordsUpdated($event)" />
      </ng-template>
    </mat-tab>
  }
  @if (isEditMode && visibleTabs()['family']) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-full">Family</span>
        <span class="tab-short">Family</span>
      </ng-template>
      <ng-template matTabContent>
        <app-family-tab />
      </ng-template>
    </mat-tab>
  }
  @if (isEditMode && visibleTabs()['salary1']) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-full">Salary 1</span>
        <span class="tab-short">Sal. 1</span>
      </ng-template>
      <ng-template matTabContent>
        <app-salary1-tab [keywords]="companyKeywords()" (keywordsUpdated)="onKeywordsUpdated($event)" />
      </ng-template>
    </mat-tab>
  }
  @if (isEditMode && visibleTabs()['salary2']) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-full">Salary 2</span>
        <span class="tab-short">Sal. 2</span>
      </ng-template>
      <ng-template matTabContent>
        <app-salary2-tab [keywords]="companyKeywords()" (keywordsUpdated)="onKeywordsUpdated($event)" />
      </ng-template>
    </mat-tab>
  }
  @if (isEditMode && visibleTabs()['accounting']) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-full">Accounting</span>
        <span class="tab-short">Acct.</span>
      </ng-template>
      <ng-template matTabContent>
        <app-accounting-tab [keywords]="companyKeywords()" (keywordsUpdated)="onKeywordsUpdated($event)" />
      </ng-template>
    </mat-tab>
  }
  @if (isEditMode && visibleTabs()['society']) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-full">Society</span>
        <span class="tab-short">Society</span>
      </ng-template>
      <ng-template matTabContent>
        <app-society-tab [keywords]="companyKeywords()" (keywordsUpdated)="onKeywordsUpdated($event)" />
      </ng-template>
    </mat-tab>
  }
  @if (isEditMode && visibleTabs()['employees']) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-full">Employees</span>
        <span class="tab-short">Empl.</span>
      </ng-template>
      <ng-template matTabContent>
        <app-employees-tab [keywords]="companyKeywords()" (keywordsUpdated)="onKeywordsUpdated($event)" />
      </ng-template>
    </mat-tab>
  }
  @if (isEditMode && visibleTabs()['energyWater']) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-full">Energy & Water</span>
        <span class="tab-short">E&W</span>
      </ng-template>
      <ng-template matTabContent>
        <app-energy-water-tab [keywords]="companyKeywords()" (keywordsUpdated)="onKeywordsUpdated($event)" />
      </ng-template>
    </mat-tab>
  }
  @if (isEditMode && visibleTabs()['emissionsWaste']) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-full">Emissions & Waste</span>
        <span class="tab-short">Em&W</span>
      </ng-template>
      <ng-template matTabContent>
        <app-emissions-waste-tab [keywords]="companyKeywords()" (keywordsUpdated)="onKeywordsUpdated($event)" />
      </ng-template>
    </mat-tab>
  }
  @if (isEditMode && visibleTabs()['votingResults']) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-full">Voting Results</span>
        <span class="tab-short">Voting</span>
      </ng-template>
      <ng-template matTabContent>
        <app-voting-results-tab [keywords]="companyKeywords()" (keywordsUpdated)="onKeywordsUpdated($event)" />
      </ng-template>
    </mat-tab>
  }
  @if (isEditMode && visibleTabs()['messages']) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-full">Messages</span>
        <span class="tab-short">Msgs.</span>
      </ng-template>
      <ng-template matTabContent>
        <app-messages-tab />
      </ng-template>
    </mat-tab>
  }
</mat-tab-group>
